<template><div class="ai-empty"><b-icon :icon="icon" /><h4>{{ title }}</h4><p>{{ message }}</p></div></template>
<script>export default { props: { icon: { default: 'inbox' }, title: { default: 'Nothing here yet' }, message: { default: 'New activity will appear here.' } } }</script>

